import { User as UserIcon } from '@otp/icons';
import { Card, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { User } from 'src/graphql/generated/graphql';
import { UserCertificates } from '../organisation/manage-otps/user-details/user-certificates/user-certificates';

type UserDetailsProps = {
  user: User;
};

export const UserDetails = ({ user }: UserDetailsProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'user-profile' });

  return (
    <>
      <Typography
        variant="subtitle1"
        sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
      >
        <UserIcon /> {t('details.your-profile')}
      </Typography>
      <Card className="w-full">
        <div className="flex flex-row justify-between gap-4">
          <Typography>{t('details.email')}</Typography>
          <Typography>{user.email}</Typography>
        </div>
        <div className="flex flex-row justify-between gap-4">
          <Typography>{t('details.communication-email')}</Typography>
          <Typography>{user.communicationEmail}</Typography>
        </div>
        <div className="flex flex-row justify-between gap-4">
          <Typography>{t('details.preferred-email-language')}</Typography>
          <Typography>{user.preferredEmailLanguage}</Typography>
        </div>
        <div className="flex flex-row justify-between gap-4">
          <Typography>{t('details.is-receiving-text-messages')}</Typography>
          <Typography>
            {user.isReceivingTextMessages ? t('details.yes') : t('details.no')}
          </Typography>
        </div>
      </Card>
      <Card className="w-full">
        <Typography variant="subtitle1" fontWeight="bold">
          {t('details.about-me')}
        </Typography>
        <div dangerouslySetInnerHTML={{ __html: user.aboutMe ?? '' }} />
      </Card>
      <UserCertificates userId={user.id} withoutActions />
    </>
  );
};
